import {
  getTimeSlots as publicGetTimeSlots,
  checkTimeSlot as publicCheckTimeSlot,
  getScheduledTimeSlots as publicGetScheduledTimeSlots,
} from './table-reservations-v1-time-slot-time-slots.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getTimeSlots: MaybeContext<
  BuildRESTFunction<typeof publicGetTimeSlots> & typeof publicGetTimeSlots
> = /*#__PURE__*/ createRESTModule(publicGetTimeSlots);
export const checkTimeSlot: MaybeContext<
  BuildRESTFunction<typeof publicCheckTimeSlot> & typeof publicCheckTimeSlot
> = /*#__PURE__*/ createRESTModule(publicCheckTimeSlot);
export const getScheduledTimeSlots: MaybeContext<
  BuildRESTFunction<typeof publicGetScheduledTimeSlots> &
    typeof publicGetScheduledTimeSlots
> = /*#__PURE__*/ createRESTModule(publicGetScheduledTimeSlots);

export {
  Status,
  TableCombinationConflictType,
  ReservationLocationConflictType,
  Type,
  ExperienceTableCombinationConflictType,
  ExperienceConflictType,
  TimeSlotAvailabilityType,
  TableConflictType,
  TimeSlotAvailabilityTimeSlotAvailabilityType,
} from './table-reservations-v1-time-slot-time-slots.universal.js';
export {
  TimeSlot,
  TimeSlotTableCombination,
  MaybeTableCombinations,
  GetTimeSlotsRequest,
  GetTimeSlotsResponse,
  CheckReservationDetailsRequest,
  MaybeTableIds,
  CheckReservationDetailsResponse,
  TableCombinationAvailability,
  ExperienceTableCombinationAvailability,
  StandardOptions,
  ExperienceOptions,
  Table,
  TableConflict,
  TableCombination,
  TableCombinationConflict,
  ReservationLocationConflict,
  TableReservedConflict,
  TimeSlotAvailability,
  TimeSlotAvailabilityOptionsOneOf,
  CheckTimeSlotRequest,
  CheckTimeSlotResponse,
  V1TimeSlotAvailability,
  V1TimeSlotAvailabilityOptionsOneOf,
  TimeSlotAvailabilityStandardOptions,
  TimeSlotAvailabilityExperienceOptions,
  GetScheduledTimeSlotsRequest,
  TimeRange,
  GetScheduledTimeSlotsResponse,
  GetTimeSlotsOptions,
  CheckTimeSlotOptions,
  GetScheduledTimeSlotsOptions,
} from './table-reservations-v1-time-slot-time-slots.universal.js';
export {
  StatusWithLiterals,
  TableCombinationConflictTypeWithLiterals,
  ReservationLocationConflictTypeWithLiterals,
  TypeWithLiterals,
  ExperienceTableCombinationConflictTypeWithLiterals,
  ExperienceConflictTypeWithLiterals,
  TimeSlotAvailabilityTypeWithLiterals,
  TableConflictTypeWithLiterals,
  TimeSlotAvailabilityTimeSlotAvailabilityTypeWithLiterals,
} from './table-reservations-v1-time-slot-time-slots.universal.js';
